export function shouldResetOnConnected(turnToken: number, lastResetToken: number): boolean {
  return turnToken !== lastResetToken;
}

export function shouldPreserveStreamedMessage(
  nextMessage: string | undefined,
  priorMessage: string | undefined,
): boolean {
  return !(nextMessage ?? "").trim() && !!(priorMessage ?? "").trim();
}

export function isNonEmptyMessageContent(content: unknown): boolean {
  if (typeof content === "string") return content.trim().length > 0;
  return content != null;
}

export function dropEmptyContentMessages<T extends { content?: unknown }>(messages: T[]): T[] {
  if (!Array.isArray(messages)) return [];
  return messages.filter((message) => isNonEmptyMessageContent(message?.content));
}
